import { render } from "./FilterCustomerMappingVendor.vue?vue&type=template&id=c2bfc30a"
import script from "./FilterCustomerMappingVendor.vue?vue&type=script&lang=js"
export * from "./FilterCustomerMappingVendor.vue?vue&type=script&lang=js"
script.render = render

export default script